import { render, staticRenderFns } from "./mainPanel.vue?vue&type=template&id=276da70f&scoped=true"
import script from "./mainPanel.vue?vue&type=script&lang=js"
export * from "./mainPanel.vue?vue&type=script&lang=js"
import style0 from "./mainPanel.vue?vue&type=style&index=0&id=276da70f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276da70f",
  null
  
)

export default component.exports